import { render, staticRenderFns } from "./ReprintForm.vue?vue&type=template&id=38261096&"
import script from "./ReprintForm.vue?vue&type=script&lang=js&"
export * from "./ReprintForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports